import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Button } from 'react-bootstrap';
const isObject = require('lodash/isObject');
const get = require('lodash/get');
import { withRouter } from 'react-router-dom';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const UriUtil = require('../../util/UriUtil');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');
import WithOrganizationPrivacyPolicies from '../DataHOCs/WithOrganizationPrivacyPolicies';
import AccessibleIcon from '../common/AccessibleIcon';
import SortableTableClassic from '../table/SortableTableClassic';
import Tooltip from '../common/Tooltip';
import ErrorBox from '../common/ErrorBox';
import ConfirmModal from '../modal/ConfirmModal';
import ConfirmPhraseModal from '../modal/ConfirmPhraseModal';

const privacyPolicyShape = PropTypes.shape({
    privacy_policy_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    modified_at: PropTypes.string.isRequired,
    activity_count: PropTypes.number.isRequired,
    data: PropTypes.shape({
        start: PropTypes.object,
        end: PropTypes.object,
    })
});

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgPrivacyPolicies: PropTypes.arrayOf(privacyPolicyShape).isRequired,
    canEditPrivacyPolicies: PropTypes.bool.isRequired,
    backHandler: PropTypes.func,
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
};

const defaultProps = {};

class OrgPrivacyPoliciesView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.gotoNewPolicy = this.gotoNewPolicy.bind(this);
        this.gotoEditPolicy = this.gotoEditPolicy.bind(this);
        this.gotoRootView = this.gotoRootView.bind(this);
    }

    gotoNewPolicy() {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: UriUtil.addObjToExistingQueryString(this.props.location, { pp: 'new' }, true),
        });

    }

    gotoEditPolicy(e, ppId) {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: UriUtil.addObjToExistingQueryString(this.props.location, { pp: ppId }, true),
        });        
    }

    gotoRootView() {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: UriUtil.addObjToExistingQueryString(this.props.location, { pp: '' }, true),
        });
    }

    render() {
        const queryObj = UriUtil.parseLocationSearchString(this.props.location);
        if (!!queryObj && queryObj.pp) {
            if (queryObj.pp === 'new') {
                return (
                    <NewPrivacyPolicy
                        orgId={this.props.orgId}
                        canEditPrivacyPolicies={this.props.canEditPrivacyPolicies}
                        backHandler={this.gotoRootView}
                    />
                );
            }
            else {
                const privacyPolicy = this.props.orgPrivacyPolicies.find(pp => pp.privacy_policy_id === queryObj.pp);
                return (
                    <EditPrivacyPolicy
                        orgId={this.props.orgId}
                        privacyPolicyId={queryObj.pp}
                        privacyPolicy={privacyPolicy}
                        notFound={!privacyPolicy}
                        canEditPrivacyPolicies={this.props.canEditPrivacyPolicies}
                        backHandler={this.gotoRootView}
                    />
                );
            }
        }

        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        {(!!this.props.backHandler) &&
                                <button
                                    className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                                    onClick={this.props.backHandler}
                                    title={Strings['en'].common.BACK}
                                >
                                    <AccessibleIcon label={Strings['en'].common.BACK}>
                                        <span className="fa fa-chevron-left" aria-hidden={true}/>
                                    </AccessibleIcon>
                                </button>
                        }
                        <h2 className="heading-lg">{this.props.heading}</h2>
                    </div>
                    <ul className="inline-list channelHeadingFlex__rightControl">
                        <li>
                            <button
                                className="btn btn-primary glyph btn-circle btn-lg"
                                onClick={this.gotoNewPolicy}
                                title={Strings['en'].privacy_policy.ADD_PP}
                            >
                                <AccessibleIcon label={Strings['en'].privacy_policy.ADD_PP}>
                                    <span className="fa fa-plus" aria-hidden={true} />
                                </AccessibleIcon>
                            </button>
                        </li>
                    </ul>
                    <div className="float-clear-r"/>
                </div>

                <div className="tile-dash-floating margin-bottom-xl">
                    {(this.props.orgPrivacyPolicies.length > 0) ?
                        <SortableTableClassic
                            classNameTableContainer="margin-bottom-xl"
                            uniqueRowKey="privacy_policy_id"
                            onRowClick={this.gotoEditPolicy}
                            rows={this.props.orgPrivacyPolicies}
                            dateFormat="YYYY-MM-DD HH:mm zz"
                            defaultSort={{ key:'name', type:'string', asc: true }}
                            tableHeight={500}
                            columns={[
                                {
                                    displayName: 'Policy Name',
                                    key: 'name',
                                    size: 2,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Attached Activities',
                                    key: 'activity_count',
                                    size: 2,
                                    type: 'number'
                                },
                                {
                                    displayName: 'Created At',
                                    key: 'created_at',
                                    size: 3,
                                    type: 'date'
                                },
                                {
                                    displayName: 'Last Modified',
                                    key: 'modified_at',
                                    size: 3,
                                    type: 'date'
                                },
                            ]}
                        />
                        :
                        <div>{Strings['en'].privacy_policy.NO_POLICIES}</div>
                    }
                </div>
            </div>
        );
    }
}

OrgPrivacyPoliciesView.propTypes = propTypes;
OrgPrivacyPoliciesView.defaultProps = defaultProps;

export default WithOrganizationPrivacyPolicies(withRouter(OrgPrivacyPoliciesView));

const DEFAULT_NEW_PP = {
    name: Strings['en'].privacy_policy.NEW_PP,
    data: {
        start: {
            title: Strings['en'].privacy_policy.DEFAULT_PP_START_TITLE,
            body: Strings['en'].privacy_policy.DEFAULT_PP_START_BODY,
            label_advance: Strings['en'].privacy_policy.DEFAULT_PP_START_LABEL_ADVANCE,
        },
        end: {
            title: Strings['en'].privacy_policy.DEFAULT_PP_END_TITLE,
            body: Strings['en'].privacy_policy.DEFAULT_PP_END_BODY,
            label_share: Strings['en'].privacy_policy.DEFAULT_PP_END_LABEL_SHARE,
            label_do_not_share: Strings['en'].privacy_policy.DEFAULT_PP_END_LABEL_DO_NOT_SHARE,
        },
    },
};

// NewPrivacyPolicy --------------------------------------------------------------------------------------------

const newPrivacyPolicyPropTypes = {
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    backHandler: PropTypes.func.isRequired,
};
const newPrivacyPolicyDefaultProps = {};

class NewPrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newPolicy: DEFAULT_NEW_PP,
            addActionId: null,
            addActionError: null,
        };

        this.confirmAdd = this.confirmAdd.bind(this);
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrganizationStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrganizationStoreChange(newState) {
        if (newState.action.id === this.state.addActionId) {
            if (newState.action.error) {
                this.setState({ addActionId: null, addActionError: newState.action.error });
            }
            else {
                this.setState({ addActionId: null }, () => {
                    this.props.backHandler();
                });
            }
        }
    }

    confirmAdd(newPolicy) {
        const editActionId = uuid.v4();
        this.setState({ addActionId: editActionId, addActionError: null }, () => {
            OrganizationActions.addOrgPrivacyPolicy(editActionId, {
                orgId: this.props.orgId,
                name: newPolicy.name,
                data: newPolicy.data,
            });
        });
    }

    render() {
        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        <button
                            className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                            onClick={this.props.backHandler}
                            title={Strings['en'].common.BACK}
                        >
                            <AccessibleIcon label={Strings['en'].common.BACK}>
                                <span className="fa fa-chevron-left" aria-hidden={true}/>
                            </AccessibleIcon>
                        </button>
                        <h2 className="heading-lg">{Strings['en'].privacy_policy.ADD_PP}</h2>
                    </div>
                </div>

                <ErrorBox error={this.state.addActionError} />
                <PolicyEditor
                    overrideDirty
                    canEditPrivacyPolicies={this.props.canEditPrivacyPolicies}
                    privacyPolicy={this.state.newPolicy}
                    confirm={this.confirmAdd}
                    confirmLabel={Strings['en'].privacy_policy.CONFIRM_NEW_LABEL}
                />
            </div>
        );
    }
}

NewPrivacyPolicy.propTypes = newPrivacyPolicyPropTypes;
NewPrivacyPolicy.defaultProps = newPrivacyPolicyDefaultProps;


// EditPrivacyPolicy --------------------------------------------------------------------------------------------

const editPrivacyPolicyPropTypes = {
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    notFound: PropTypes.bool.isRequired,
    privacyPolicyId: PropTypes.string.isRequired,
    privacyPolicy: privacyPolicyShape,
    backHandler: PropTypes.func.isRequired,
};
const editPrivacyPolicyDefaultProps = {
    privacyPolicy: null,
};

class EditPrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editActionId: null,
            editActionError: null,
            deleteActionId: null,
            deleteActionError: null,
            showConfirmDeleteModal: false,
            showConfirmPhraseDeleteModal: false,
            editedPolicy: isObject(props.privacyPolicy) ? { ... props.privacyPolicy } : {},
        };

        this.confirmEdit = this.confirmEdit.bind(this);
        this.showConfirmDeleteModal = this.showConfirmDeleteModal.bind(this);
        this.hideConfirmDeleteModals = this.hideConfirmDeleteModals.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrganizationStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrganizationStoreChange(newState) {
        if (newState.action.id === this.state.editActionId) {
            if (newState.action.error) {
                this.setState({ editActionId: null, editActionError: newState.action.error });
            }
            else {
                this.setState({ editActionId: null });
            }
        }
        else if (newState.action.id === this.state.deleteActionId) {
            if (newState.action.error) {
                this.setState({
                    deleteActionId: null,
                    showConfirmDeleteModal: false,
                    showConfirmPhraseDeleteModal: false,
                    editActionError: newState.action.error
                });
            }
            else {
                this.setState({
                    deleteActionId: null,
                    showConfirmDeleteModal: false,
                    showConfirmPhraseDeleteModal: false,
                }, () => {
                    this.props.backHandler();
                });
            }
        }
    }

    confirmEdit(newPolicy) {
        const editActionId = uuid.v4();
        this.setState({ editActionId: editActionId, editActionError: null }, () => {
            OrganizationActions.updateOrgPrivacyPolicy(editActionId, {
                orgId: this.props.orgId,
                privacyPolicyId: this.props.privacyPolicyId,
                name: newPolicy.name,
                data: newPolicy.data,
            });
        });
    }

    showConfirmDeleteModal() {
        if (this.props.privacyPolicy.activity_count > 0) {
            this.setState({ showConfirmPhraseDeleteModal: true });
        }
        else {
            this.setState({ showConfirmDeleteModal: true });
        }

    }

    hideConfirmDeleteModals() {
        this.setState({ showConfirmDeleteModal: false, showConfirmPhraseDeleteModal: false });
    }

    confirmDelete() {
        const deleteActionId = uuid.v4();
        this.setState({ deleteActionId: deleteActionId, deleteActionError: null }, () => {
            OrganizationActions.deleteOrgPrivacyPolicy(deleteActionId, {
                orgId: this.props.orgId,
                privacyPolicyId: this.props.privacyPolicyId,
            });
        });
    }

    render() {
        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        <button
                            className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                            onClick={this.props.backHandler}
                            title={Strings['en'].common.BACK}
                        >
                            <AccessibleIcon label={Strings['en'].common.BACK}>
                                <span className="fa fa-chevron-left" aria-hidden={true}/>
                            </AccessibleIcon>
                        </button>
                        <h2 className="heading-lg">{Strings['en'].privacy_policy.EDIT_PP}</h2>
                    </div>
                    {(!this.props.notFound) &&
                        <ul className="inline-list channelHeadingFlex__rightControl">
                            <li>
                                <button
                                    className="btn btn-danger glyph btn-circle btn-lg"
                                    onClick={this.showConfirmDeleteModal}
                                    title={Strings['en'].privacy_policy.DELETE_PP}
                                >
                                    <AccessibleIcon label={Strings['en'].privacy_policy.DELETE_PP}>
                                        <span className="fa fa-close" aria-hidden={true} />
                                    </AccessibleIcon>
                                </button>
                            </li>
                        </ul>
                    }
                    <div className="float-clear-r"/>
                </div>

                <ErrorBox error={this.state.editActionError} />
                {(this.props.notFound) ?
                    <div>
                        {Strings['en'].privacy_policy.INVALID_ID} ({this.props.privacyPolicyId})
                    </div>
                    :
                    <PolicyEditor
                        overrideDirty={!!this.state.editActionError}
                        canEditPrivacyPolicies={this.props.canEditPrivacyPolicies}
                        privacyPolicy={this.state.editedPolicy}
                        confirm={this.confirmEdit}
                        confirmLabel={Strings['en'].privacy_policy.CONFIRM_EDIT_LABEL}
                    />
                }
                {(this.state.showConfirmDeleteModal) &&
                    <ConfirmModal
                        show
                        modalTitle={Strings['en'].privacy_policy.DELETE_PP}
                        text={Strings['en'].privacy_policy.CONFIRM_DELETE_WARNING}
                        buttonText={Strings['en'].common.DELETE_LC}
                        closeHandler={this.hideConfirmDeleteModals}
                        confirmHandler={this.confirmDelete}
                    />
                }
                {(this.state.showConfirmPhraseDeleteModal) &&
                    <ConfirmPhraseModal
                        closeHandler={this.hideConfirmDeleteModals}
                        cancelHandler={this.hideConfirmDeleteModals}
                        confirmButtonBsStyle="danger"
                        confirmPhrase={Strings['en'].common.DELETE_LC}
                        confirmHandler={this.confirmDelete}
                        cancelButtonText={Strings['en'].common.CANCEL_LC}
                    >
                        <div className="margin-bottom-lg">
                            <p>{Strings['en'].privacy_policy.CONFIRM_DELETE_WARNING_ACTS}</p>
                            <p className="margin-top-md font-weight-bold">{Strings['en'].privacy_policy.CONFIRM_DELETE_WARNING_ACT_COUNT} {this.props.privacyPolicy.activity_count}</p>
                            <p className="margin-top-md">{Strings['en'].privacy_policy.CONFIRM_DELETE_WARNING}</p>
                        </div>
                    </ConfirmPhraseModal>

                }
            </div>
        );
    }
}

EditPrivacyPolicy.propTypes = editPrivacyPolicyPropTypes;
EditPrivacyPolicy.defaultProps = editPrivacyPolicyDefaultProps;

const policyEditorPropTypes = {
    startDirty: PropTypes.bool,
    overrideDirty: PropTypes.bool,
    canEditPrivacyPolicies: PropTypes.bool.isRequired,
    privacyPolicy: PropTypes.object.isRequired,
    confirm: PropTypes.func.isRequired,
    confirmLabel: PropTypes.string.isRequired,
};

const policyEditorDefaultProps = {
    startDirty: false,
    overrideDirty: false,
};

class PolicyEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startEnabled: !!props.privacyPolicy.data.start,
            endEnabled: !!props.privacyPolicy.data.end,
            formDirty: props.startDirty,
        };

        this.policyName = React.createRef();
        this.startTitle = React.createRef();
        this.startBody = React.createRef();
        this.startLabelAdvance = React.createRef();
        this.endTitle = React.createRef();
        this.endBody = React.createRef();
        this.endLabelShare = React.createRef();
        this.endLabelDoNotShare = React.createRef();
        this.toggleStartEnabled = this.toggleStartEnabled.bind(this);
        this.toggleEndEnabled = this.toggleEndEnabled.bind(this);
        this.ensureDirty = this.ensureDirty.bind(this);
        this.confirm = this.confirm.bind(this);
    }


    toggleStartEnabled(e) {
        this.setState({ startEnabled: e.target.checked, formDirty: true });
    }

    toggleEndEnabled(e) {
        this.setState({ endEnabled: e.target.checked, formDirty: true });
    }

    ensureDirty() {
        if (!this.state.formDirty) {
            this.setState({ formDirty: true });
        }
    }

    confirm() {
        const newPolicy = {
            name: this.policyName.current.value,
            data: {
                start: null,
                end: null,
            },
        };

        if (this.state.startEnabled) {
            newPolicy.data.start = {
                title: this.startTitle.current.value,
                body: this.startBody.current.value,
                label_advance: this.startLabelAdvance.current.value,
            };
        }

        if (this.state.endEnabled) {
            newPolicy.data.end = {
                title: this.endTitle.current.value,
                body: this.endBody.current.value,
                label_share: this.endLabelShare.current.value,
                label_do_not_share: this.endLabelDoNotShare.current.value,
            };
        }

        this.setState({ formDirty: false }, () => {
            this.props.confirm(newPolicy);
        });
    }

    render() {
        return (
            <Card body bg="light">
                <Form bsPrefix="form tile-dash-floating margin-bottom-xl">
                    <Form.Group controlId="policy-name">
                        <Form.Label>{Strings['en'].privacy_policy.POLICY_NAME_LABEL}</Form.Label>
                        <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                            {Strings['en'].privacy_policy.POLICY_NAME_TT}
                        </Tooltip>
                        <Form.Control
                            as="input"
                            ref={this.policyName}
                            defaultValue={this.props.privacyPolicy.name}
                            onChange={this.ensureDirty}
                        />
                    </Form.Group>

                    <h2 className="margin-top-xl">{Strings['en'].privacy_policy.POLICY_START_NAME}</h2>
                    <p className="font-size-14px margin-bottom-md">{Strings['en'].privacy_policy.POLICY_START_DESC}</p>


                    <Form.Group>
                        <Form.Check>
                            <Form.Check.Input
                                id="policy-enable-start"
                                checked={this.state.startEnabled}
                                onChange={this.toggleStartEnabled}
                            />
                            <Form.Check.Label htmlFor="policy-enable-start" bsPrefix="form-check-label margin-left-sm font-size-14px">
                                {Strings['en'].privacy_policy.POLICY_START_ENABLED}
                            </Form.Check.Label>
                        </Form.Check>
                    </Form.Group>

                    {(this.state.startEnabled) &&
                        <div>
                            <Form.Group controlId="policy-start-title">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_START_TITLE_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_START_TITLE_TT}
                                </Tooltip>
                                <Form.Control
                                    as="input"
                                    ref={this.startTitle}
                                    defaultValue={get(this.props.privacyPolicy.data.start, 'title', DEFAULT_NEW_PP.data.start.title)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>

                            <Form.Group controlId="policy-start-body">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_START_BODY_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_START_BODY_TT}
                                </Tooltip>
                                <Form.Control
                                    as="textarea"
                                    ref={this.startBody}
                                    defaultValue={get(this.props.privacyPolicy.data.start, 'body', DEFAULT_NEW_PP.data.start.body)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>

                            <Form.Group controlId="policy-start-label-advance">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_START_LABEL_ADVANCE_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_START_LABEL_ADVANCE_TT}
                                </Tooltip>
                                <Form.Control
                                    as="input"
                                    ref={this.startLabelAdvance}
                                    defaultValue={get(this.props.privacyPolicy.data.start, 'label_advance', DEFAULT_NEW_PP.data.start.label_advance)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>
                        </div>
                    }

                    <h2 className="margin-top-xl">{Strings['en'].privacy_policy.POLICY_END_NAME}</h2>
                    <p className="font-size-14px margin-bottom-md">{Strings['en'].privacy_policy.POLICY_END_DESC}</p>

                    <Form.Group>
                        <Form.Check>
                            <Form.Check.Input
                                id="policy-enable-end"
                                checked={this.state.endEnabled}
                                onChange={this.toggleEndEnabled}
                            />
                            <Form.Check.Label htmlFor="policy-enable-end" bsPrefix="form-check-label margin-left-sm font-size-14px">
                                {Strings['en'].privacy_policy.POLICY_END_ENABLED}
                            </Form.Check.Label>
                        </Form.Check>
                    </Form.Group>

                    {(this.state.endEnabled) &&
                        <div>
                            <Form.Group controlId="policy-end-title">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_END_TITLE_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_END_TITLE_TT}
                                </Tooltip>
                                <Form.Control
                                    as="input"
                                    ref={this.endTitle}
                                    defaultValue={get(this.props.privacyPolicy.data.end, 'title', DEFAULT_NEW_PP.data.end.title)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>

                            <Form.Group controlId="policy-end-body">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_END_BODY_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_END_BODY_TT}
                                </Tooltip>
                                <Form.Control
                                    as="textarea"
                                    ref={this.endBody}
                                    defaultValue={get(this.props.privacyPolicy.data.end, 'body', DEFAULT_NEW_PP.data.end.body)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>

                            <Form.Group controlId="policy-start-label-share">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_END_LABEL_SHARE_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_END_LABEL_SHARE_TT}
                                </Tooltip>
                                <Form.Control
                                    as="input"
                                    ref={this.endLabelShare}
                                    defaultValue={get(this.props.privacyPolicy.data.end, 'label_share', DEFAULT_NEW_PP.data.end.label_share)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>

                            <Form.Group controlId="policy-start-label-do-not-share">
                                <Form.Label>{Strings['en'].privacy_policy.POLICY_END_LABEL_DO_NOT_SHARE_LABEL}</Form.Label>
                                <Tooltip id="pp-name" className="margin-left-sm" placement="right">
                                    {Strings['en'].privacy_policy.POLICY_END_LABEL_DO_NOT_SHARE_TT}
                                </Tooltip>
                                <Form.Control
                                    as="input"
                                    ref={this.endLabelDoNotShare}
                                    defaultValue={get(this.props.privacyPolicy.data.end, 'label_do_not_share', DEFAULT_NEW_PP.data.end.label_do_not_share)}
                                    onChange={this.ensureDirty}
                                />
                            </Form.Group>
                        </div>
                    }

                    <div className="text-right">
                        <Button
                            disabled={!this.props.canEditPrivacyPolicies || (!this.state.formDirty && !this.props.overrideDirty)}
                            onClick={this.confirm}
                        >
                            {this.props.confirmLabel}
                        </Button>
                    </div>
                </Form>
            </Card>
        );
    }
}

PolicyEditor.propTypes = policyEditorPropTypes;
PolicyEditor.defaultProps = policyEditorDefaultProps;